module.exports = __webpack_public_path__ + "static/ff-clan-std-bold-e97d0309fc3e0d667bb112de234347a5.woff2";